import { BASE_URL, API_TOKEN, FUNCTION_BASE_URL } from '../constants';

export const _fetchService = async (method, url, sendDetails) => {
  // var token = API_TOKEN;
  var token = 'davidvatine crm';

  var myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  var requestOptions = {
    method: method || 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  if (method === 'POST' || method === 'PATCH') {
    if (!sendDetails) {
      alert('Send details is required');
      return;
    }
    myHeaders.append('Content-Type', `application/json`);
    var raw = JSON.stringify(sendDetails);
    requestOptions.body = raw;
  }

  try {
    const response = fetch(`${FUNCTION_BASE_URL}${url}`, requestOptions).then(
      (res) => {
        return new Promise((resolve) => {
          const contentType = res.headers.get('content-type');
          if (contentType && contentType.indexOf('application/json') !== -1) {
            res.json().then((json) =>
              resolve({
                status: res.status,
                data: json
              })
            );
          } else {
            throw 'Something went wrong';
          }
        });
      }
    );

    return Promise.resolve(response);
  } catch (error) {
    console.log('er', error);
    return Promise.reject(error);
  }
};

export const fetchService = async (method, url, sendDetails) => {
  var token = API_TOKEN;

  var myHeaders = new Headers();
  myHeaders.append('Authorization', `Bearer ${token}`);

  var requestOptions = {
    method: method || 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  if (method === 'POST' || method === 'PATCH') {
    if (!sendDetails) {
      alert('Send details is required');
      return;
    }
    myHeaders.append('Content-Type', `application/json`);
    var raw = JSON.stringify(sendDetails);
    requestOptions.body = raw;
  }

  try {
    const response = fetch(`${BASE_URL}${url}`, requestOptions).then((res) => {
      return new Promise((resolve) => {
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.indexOf('application/json') !== -1) {
          res.json().then((json) =>
            resolve({
              status: res.status,
              data: json
            })
          );
        } else {
          throw 'Something went wrong';
        }
      });
    });

    return Promise.resolve(response);
  } catch (error) {
    console.log('er', error);
    return Promise.reject(error);
  }
};
